import { useState } from "react";
import { useHistory } from "react-router-dom";
import {
  Card,
  CardHeader,
  CardFooter,
  Row,
  Button,
  Input,
  Col,
} from "reactstrap";
import TableComponent from "components/shared/Table";

import Pagination from "components/shared/Pagination";

function HolidaysTable({
  data,
  addToggle,
  editToggle,
  deleteToggle,
  setEditData,
  setIndex,
}) {
  const history = useHistory();
  const [searchQuery, setSearchQuery] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);

  const handlePageChange = (event) => {
    setPageSize(Number(event.target.value));
    setCurrentPage(1);
  };

  const handleSearchChange = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const filteredData = data.filter((el) =>
    el.title.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const totalPages = Math.ceil(filteredData.length / pageSize);

  const adjustedCurrentPage = Math.min(currentPage, totalPages);

  const startIndex = (adjustedCurrentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;

  const slicedData = filteredData.slice(startIndex, endIndex);

  return (
    <>
      <Row>
        <div className="col">
          <Card className="shadow">
            <CardHeader className="d-lg-flex justify-content-between">
              <Col lg={6}>
                <div className="d-flex align-items-center">
                  <Button
                    size="sm"
                    color="primary"
                    onClick={() => {
                      history.push("/admin/settings/venue-setting-menu");
                    }}
                  >
                    <i className="fas fa-arrow-left "></i>
                  </Button>

                  <h3 className="pt-2">Special Holiday Schedule</h3>
                </div>
              </Col>
              <Col lg={6} className="d-lg-flex justify-content-between">
                <Input
                  className="my-2 my-lg-0 mx-0"
                  style={{ minWidth: "40%" }}
                  placeholder="Search by title"
                  value={searchQuery}
                  onChange={handleSearchChange}
                  type="text"
                />
                <Input
                  id="exampleSelect"
                  style={{ minWidth: "40%" }}
                  className="my-2 my-lg-0 mx-0 mx-lg-2"
                  value={pageSize}
                  onChange={handlePageChange}
                  type="select"
                >
                  <option value="5">Show Entries</option>
                  <option value="10">10 </option>
                  <option value="15"> 15 </option>
                  <option value="20"> 20 </option>
                </Input>

                <Button
                  className="btn-block my-2 my-lg-0 ml-auto"
                  color="primary"
                  onClick={addToggle}
                  style={{ maxWidth: "100%" }}
                >
                  Add
                </Button>
              </Col>
            </CardHeader>

            <TableComponent
              className="align-items-center table-flush"
              responsive
            >
              <thead className="thead-light">
                <tr>
                  <th scope="col">Title</th>
                  <th scope="col">Date</th>
                  <th scope="col">Actions</th>
                </tr>
              </thead>
              <tbody>
                {slicedData.length > 0 ? (
                  slicedData.map((el, id) => {
                    return (
                      <tr key={id}>
                        <th scope="row">{el?.title}</th>
                        <td>{el?.date}</td>
                        <td>
                          <Button
                            className="btn-sm"
                            color="primary"
                            onClick={() => {
                              setIndex(id);
                              setEditData(el);
                              editToggle();
                            }}
                          >
                            Edit
                          </Button>
                          <Button
                            className="btn-sm"
                            color="danger"
                            onClick={() => {
                              setEditData(el);
                              deleteToggle();
                            }}
                          >
                            Delete
                          </Button>
                        </td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-5">
                      No Holiday Added
                    </td>
                  </tr>
                )}
              </tbody>
            </TableComponent>
            <CardFooter className="py-4">
              <Pagination
                currentPage={currentPage - 1}
                totalPages={totalPages}
                onPageChange={(page) => setCurrentPage(page + 1)}
              />
            </CardFooter>
          </Card>
        </div>
      </Row>
    </>
  );
}

export default HolidaysTable;
